import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const GuernseyFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				x='0.25'
				y='0.25'
				width='19.5'
				height='13.5'
				rx='1.75'
				fill='white'
				stroke='#F5F5F5'
				strokeWidth='0.5'
			/>
			<mask
				id='mask0_2332_14877'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					x='0.25'
					y='0.25'
					width='19.5'
					height='13.5'
					rx='1.75'
					fill='white'
					stroke='white'
					strokeWidth='0.5'
				/>
			</mask>
			<g mask='url(#mask0_2332_14877)'>
				<rect
					x='7.61914'
					width='4.7619'
					height='14'
					fill='#E8112D'
				/>
				<rect
					y='4.66663'
					width='20'
					height='4.66667'
					fill='#E8112D'
				/>
				<rect
					x='9.52344'
					y='1.8667'
					width='0.952381'
					height='10.2667'
					fill='#F9DD16'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99926 11.2001L10.9516 12.1334H9.04688L9.99926 11.2001Z'
					fill='#F9DD16'
				/>
				<rect
					x='4.76172'
					y='6.53333'
					width='10.4762'
					height='0.933333'
					fill='#F9DD16'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.99926 2.80005L10.9516 1.86672H9.04688L9.99926 2.80005Z'
					fill='#F9DD16'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M5.71484 7.00002L4.76246 6.06668V7.93335L5.71484 7.00002Z'
					fill='#F9DD16'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M14.2852 7.00002L15.2375 6.06668V7.93335L14.2852 7.00002Z'
					fill='#F9DD16'
				/>
			</g>
		</svg>
	);
};

export default GuernseyFlagIcon;
